import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "./servicesPutActions";

function* servicesPut(action) {
  try {
    let response = yield call(
      requestWithSubTenantIfNeeded,
      "put",
      `services/${action.serviceId}`,
      {
        headers: action.emulateFailure ? { "x-end-with-fail": "true" } : {},
        json: action.payload,
      }
    );

    yield put(actions.requestSuccess(response.data, action.payload));

    if (action.resolve) {
      yield call(action.resolve);
    }
  } catch (error) {
    yield put(actions.requestFailure(error, action.payload));

    if (action.reject) {
      yield call(action.reject, error);
    }
  }
}

function* saga() {
  yield takeEvery(actions.SERVICES_PUT_REQUEST, servicesPut);
}

export default saga;
